import { render, staticRenderFns } from "./goodsList.vue?vue&type=template&id=64c849d5&scoped=true&"
import script from "./goodsList.vue?vue&type=script&lang=js&"
export * from "./goodsList.vue?vue&type=script&lang=js&"
import style0 from "./goodsList.vue?vue&type=style&index=0&id=64c849d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c849d5",
  null
  
)

export default component.exports